import React from 'react'
import i18n from 'i18next'

import Panel from '../../../UniformComponents/Panel'
import Button from '../../../UniformComponents/Button'

const Distribute = ({ wizardStore }) => {
    const { campaignLink, appStore } = wizardStore

    return (
        <Panel cssClass="stage-card overflow-visible">
            <div id="survey-distribute">
                <div className="distribute-empty-state-text-container">
                    <div className="distribute-empty-state-icon">
                        <i className="fal fa-link-horizontal" />
                    </div>
                    <h4>{i18n.t('views.survey.wizard.R.stage.4.header')}</h4>
                    <div className="distribute-link">
                        {campaignLink}
                    </div>
                    <Button
                        label={i18n.t('copy')}
                        onClick={() => appStore.copyText(campaignLink, i18n.t('distributionLandingScreen.campaignLink'))}
                        icon="fal fa-copy"
                        cssClass="regular tertiary"
                    />
                </div>
            </div>
        </Panel>
    )
}

export default Distribute
